module.exports = __webpack_public_path__ + "static/media/check-box.1eb3f6ef.svg";